import { Permission } from "src/entity/permission/permission";

export const roleCompanyAdmin = "Company Admin";

export const canViewTable = (permissions: string[] | null) => {
  if (permissions) {
    return (
      permissions.includes(Permission.V) ||
      permissions.includes(Permission.VO) ||
      permissions.includes(Permission.EA) ||
      permissions.includes(Permission.EO)
    );
  } else {
    return false;
  }
};

export const canApproveAndViewTable = (permissions: string[] | null) => {
  if (permissions) {
    return permissions.includes(Permission.A) || permissions.includes(Permission.VO) || permissions.includes(Permission.EO);
  } else {
    return false;
  }
};

export const canApproveAndViewMainReport = (permissions: string[] | null) => {
  if (permissions) {
    return (
      permissions.includes(Permission.V) ||
      permissions.includes(Permission.VO) ||
      permissions.includes(Permission.EA) ||
      permissions.includes(Permission.EO) ||
      permissions.includes(Permission.A)
    );
  } else {
    return false;
  }
};

export const canEditTable = (permissions: string[] | null) => {
  if (permissions) {
    return permissions.includes(Permission.EA) || permissions.includes(Permission.EO);
  } else {
    return false;
  }
};
